import { Component, Input, OnChanges, OnInit, ViewEncapsulation } from '@angular/core';
import { IMessage } from 'app/store/models/message.model';
import stripHtml from 'string-strip-html';
import { DomSanitizer } from '@angular/platform-browser';
import { IUserSessionData, UserType } from 'app/store/models/user.model';
import { PopoverOptions, PopoverPosition } from 'app/store/models/popover.model';
import { faFile } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-message-viewer',
  templateUrl: './message-viewer.component.html',
  styleUrls: ['./message-viewer.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MessageViewerComponent implements OnInit, OnChanges {
  @Input() message: IMessage;

  @Input() sessionData: IUserSessionData;

  @Input() asPlainText = false;

  @Input() showReleaseNote: boolean;

  popoverData: PopoverOptions = {
    canClose: true,
    body: 'The paperclip signals the message has a attachment. Note, some signature and logo files, appear as an attachment so not every paperclip represents a document/file. If you believe that the contact sent you an attachment you need click on the Response drop down and select Forward. This will forward the conversation including any attachments to your business email associated with your Retreva account. WARNING you may be forwarding a virus or trojan. Please take precaution when opening files on your PC.',
    position: PopoverPosition.LEFT,
    asTooltip: true,
    visible: false,
  };

  iconFile = faFile;

  constructor(private domSanitizer: DomSanitizer) {
  }

  ngOnInit() {
  }

  ngOnChanges() {
  }

  getMessageContent() {
    if (this.asPlainText) {
      return stripHtml(this.message.content);
    }
    return stripHtml(this.message.content, {
      onlyStripTags: ['img', 'IMG'],
    });
  }

  showEditContact(): boolean {
    return (
      [UserType.MASTER, UserType.MANAGER, UserType.PARTNER].indexOf(
        this.sessionData.user_type,
      ) === -1
    );
  }

  getContactRoute(): string {
    return `/user_contacts/${this.message.contact_id}/edit`;
  }

  getRecipients() {
    return this.message.recepients
      .map(r => r.replace('.devservicesend', '').replace('.servicesent', ''))
      .join(',');
  }
}
